<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="5">
        <div class="mb-5">
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'Landing' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Back to home</span>
        </div>
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text">
              <!-- form -->
              <v-col cols="12">
                <alertsp :alertdata="alertdata"></alertsp>
                <v-form
                  @submit.prevent="submitPassword"
                  ref="formpassword"
                  v-model="formin.valid"
                  lazy-validation>
                  <v-text-field
                    v-model="reset.newpassword"
                    :append-icon="formin.newpassword ? 'visibility' : 'visibility_off'"
                    :rules="[rules.required, rules.minpass]"
                    :type="formin.newpassword ? 'text' : 'password'"
                    name="newpassword"
                    label="New password"
                    hint="At least 8 characters"
                    counter
                    @click:append="formin.newpassword = !formin.newpassword">
                  </v-text-field>
                  <v-btn
                    type="submit"
                    large
                    block
                    :loading="loading.change"
                    :disabled="loading.change || !formin.valid"
                    :color="maincolor"
                    class="white--text mt-5">
                    Update password
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Resetpass',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      verify: false,
      change: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datauser: null,
    token: '',
    verified: false,
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
    },
    reset: {
      newpassword: '',
      token: '',
    },
    formin: {
      newpassword: false,
      valid: false,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  watch: {
    '$route.query.token'(val) {
      if (val) {
        this.token = val;
      }
    },
  },
  mounted() {
    if (this.$route.query.token && this.$route.query.token !== '') {
      this.token = this.$route.query.token;
    } else {
      this.alertdata.show = true;
      this.alertdata.type = 'error';
      this.alertdata.text = 'Invalid URL!';
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    submitPassword() {
      this.alertdata.show = false;
      if (this.$refs.formpassword.validate() && this.token) {
        this.reset.token = this.token;
        this.loading.change = true;
        this.axios
          .post(
            this.api + '/api/auth/updatepass',
            qs.stringify(
              this.reset,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.$refs.formpassword.reset();
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Password berhasil di update!';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.change = false;
          })
          .catch((error) => {
            this.loading.change = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
